import React, { useState } from "react";
import SegmentButton2 from "../../Admin/AdminReports/SegmentButton2";
import HiredCandidates from "../../Admin/AdminReports/HiredCandidates";
import { Box, Container } from "@mui/system";
import CandidateStatusRecruterReport from "./CandidateStatusRecruterReport";
import { useSelector } from "react-redux";
import RecruterEarning from "./RecruterEarning";
import dayjs from "dayjs";
export const CandidateStatusHeaders = [
  "No",
  "Enroll Date",
  "Candidate Name",
  "Email",
  "Contact No.",
  "Job Title",
  "Job Industry/Sector",
  "No. of Year Experiance",
  "Geographic Preference",
  "Language Proficiency",
  `Compensation Range\n ( Base Salary + Bonus In cash / year)`,
  "Resume Link",
  "Last Modified Date-Time",
  "Status",
];
export const recruterEarnings = [
  "No",
  "Enroll Date",
  "Candidate Name",
  "Email",
  "Contact No.",
  "Job Title",
  "Job Industry/Sector",
  "No. of Year Experiance",
  "Geographic Preference",
  "Language Proficiency",
  "Compensation Range \n ( Base Salary + Bonus In cash / year)",
  "Hired Date",
  "Payment Date",
  "Client Name",
  "Commission Earned",
];

const today = localStorage.getItem('serverTime') ? new Date(localStorage.getItem('serverTime')) : new Date();

export const initialStartDate = dayjs(today).subtract(1, "year").toDate();
export const initialEndDate = dayjs(today).toDate();
export const initialMonth = dayjs();
export const formatDateToYearMonth = (date) => dayjs(date).format("YYYY-MM");

export const filterReportsName = (activeButton) => {
  if (activeButton === "Recruiter_Earning") {
    return false;
  }
  return true;
};
export const getHeadersList = (activeButton) => {
  if (activeButton === "Candidate_Status_Report") {
    return CandidateStatusHeaders;
  } else if (activeButton === "Recruiter_Earning") {
    return recruterEarnings;
  }
  return CandidateStatusHeaders;
};

const RecruterReports = () => {
  let is_candidate_list =
    window.location.pathname === "/recruiter-candidate-list";
  const [activeButton, setActiveButton] = useState("Candidate_Status_Report");
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const buttonsConfig = [
    { key: "Candidate_Status_Report", label: "Candidate Status Report" },
    { key: "Recruiter_Earning", label: "Recruiter Earning" },
  ];
  const { user } = useSelector((state) => state.auth);
  const RecruiterId = user?._id?.$oid;
  const componantMap = {
    Candidate_Status_Report: CandidateStatusRecruterReport,
    Recruiter_Earning: CandidateStatusRecruterReport,
  };
  const renderComponant = () => {
    const Componant = componantMap[activeButton];
    return Componant ? (
      <Componant
        activeButton={activeButton}
        RecruiterId={RecruiterId}
        totalRecords={totalRecords}
        setTotalRecords={setTotalRecords}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
    ) : null;
  };

  return (
    <>
      {is_candidate_list ? (
        <Container maxWidth="xl">
          <CandidateStatusRecruterReport
            headers={CandidateStatusHeaders}
            RecruiterId={RecruiterId}
            candidate_list={true}
            totalRecords={totalRecords}
            setTotalRecords={setTotalRecords}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        </Container>
      ) : (
        <>
          <SegmentButton2
            buttonsConfig={buttonsConfig}
            setActiveButton={setActiveButton}
            activeButton={activeButton}
          />
          <Container maxWidth="xl">{renderComponant()}</Container>
        </>
      )}
    </>
  );
};

export default RecruterReports;
